<template>
  <button
    :type="type"
    :class="[
      'btn d-flex align-items-center position-relative',
      outlined ? `btn-outline-${variant}` : `btn-${variant}`,
      size ? `btn-${size}` : undefined,
      {'btn-icon': icon},
    ]"
    :disabled="disabled"
    :aria-disabled="disabled"
    :name="name"
    :aria-label="ariaLabel"
    role="button"
  >
    <TransitionGroup v-if="type === 'submit'" name="list" tag="ul" class="group">
      <li v-if="loading" :key="0">
        <span class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true" />
      </li>
      <li :key="1" class="d-flex align-items-center h-100"><slot></slot></li>
    </TransitionGroup>
    <slot v-else>
      <Icon v-if="icon" :icon="icon" color="currentColor" />
    </slot>
    <span
      v-if="badge"
      :class="[
        'position-absolute top-0 start-100 translate-middle badge rounded-pill bg-danger',
        {'p-2 rounded-circle': badge === true},
      ]"
      style="font-size: 0.75em"
    >
      {{ badge === true ? undefined : badge }}
      <span class="visually-hidden">New alerts</span>
    </span>
  </button>
</template>
<script lang="ts" setup>
import {type BootstrapButtonProps} from '@/components/shared/bootstrap/BootstrapButton/BootstrapButton.types';
const {
  variant = 'primary',
  disabled = false,
  outlined = false,
  loading = false,
  type = 'button',
  size = undefined,
  name = undefined,
  icon = undefined,
} = defineProps<BootstrapButtonProps>();
</script>
<style lang="scss" scoped>
.group {
  display: flex;
  margin: 0;
  padding: 0;
  list-style: none;
}

.list-move, /* apply transition to moving elements */
.list-enter-active,
.list-leave-active {
  transition: all 0.2s ease;
}

.list-enter,
.list-leave-to {
  opacity: 0;
}

/* ensure leaving items are taken out of layout flow so that moving animations can be calculated correctly. */
.list-leave-active {
  position: absolute;
}
</style>
